<template>
    <div class="maintain" v-loading.fullscreen.lock="loading">
        <p class="title">维护状态配置</p>
        <el-form :label-position="labelPosition" label-width="350px" :model="form">
            <el-form-item label="维护状态:">
                <el-switch v-model="form.isMaintaining" active-color="#13ce66" inactive-color="#ff4949" @change="isMaintainingChange">
                </el-switch>
            </el-form-item>
            <el-form-item label="维护公告:" v-show="form.isMaintaining">
                <el-input v-model="form.description" placeholder="简短说明维护原因，预计恢复时间..."></el-input>
            </el-form-item>
        </el-form>
        <el-button class="button" @click="doMaintain">确定</el-button>
    </div>
</template>

<script>
    import {
        getMaintain,
        postMaintain
    } from "@/api/zone.js";
    export default {
        name: "maintain",
        data() {
            return {
                loading: false,
                labelPosition: 'right',
                form: {
                    isMaintaining: false,
                    description: '',
                },
            };
        },
        mounted() {
        },
        created() {
            this.init()
        },
        methods: {
            isMaintainingChange(val){
                if(val && this.form.description == 'null'){
                    this.form.description = ''
                }
            },
            doMaintain(){
                if(this.form.description.replace(/\s/g,"").length == 0){
                    if(this.form.isMaintaining){
                        this.$message.error('请输入维护公告!')
                        return
                    }
                    this.form.description = 'null'
                }
                postMaintain(this.form).then(res => {
                    if (res.status == 0) {
                        this.$message.success('修改成功')
                        this.form.description == ''
                        this.init()
                    }
                })
            },
            init() {
                getMaintain().then(res=>{
                    if(res.status == 0){
                        this.form.isMaintaining = res.isMaintaining
                        this.form.description = res.description
                    }
                })
            },
        },
    };
</script>

<style scoped>
    .maintain {
        width: 100%;
        padding: 50px;
    }

    .title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 50px;
    }

    .maintain .mask {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

        .maintain .mask .mask-c {
            width: 70%;
            background-color: #fff;
            margin: 0 auto;
            margin-top: 1%;
            overflow: hidden;
        }

            .maintain .mask .mask-c .container {
                height: 85vh;
                width: 90%;
                background-color: #000000;
                margin: 0 auto;
                margin-top: 2%;
            }

    .footer {
        float: right;
        margin: 2% 50px 10px 0;
    }

    .ellipsis {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .button{
        display: block;
        margin: 0 auto;
    }
</style>
